import { Segment, PointDirection, findFirstIntersectionsReversedWithCrossDirection } from "./intersection.Math";





export function computeBbScan(data: anychart.data.Table, bbRule:any):any {
  
  //console.log("calculate bB");
 
//return false;;
  let period = bbRule.period;
  let deviation = bbRule.deviation;

  

  var mapping = data.mapAs(
    {open: 1, high: 2, low: 3, close: 4, value: 4}
);
 // mapping.addField('value', 4, 'last');
  mapping.addField("dt", 0);

  // Create computer.
  var computer = data.createComputer(mapping);

  var context = anychart.math.bbands.initContext(period, deviation);

  // Set init context.
  computer.setContext(context);

  computer.setStartFunction( ctx=>{
                            anychart.math.bbands.startFunction(<anychart.math.bbands.Context>ctx);
                          });

    
    computer.setCalculationFunction(  (rowProxy:anychart.data.TableComputer.RowProxy, context:Object)=>{
        anychart.math.bbands.calculationFunction(rowProxy, <anychart.math.bbands.Context>context)
    });;


    // computer.addOutputField('macdResult');
    // computer.addOutputField('signalResult');
    // computer.addOutputField('histogramResult');

    var indicatorMapping = data.mapAs(
                                            {
                                              upperResult:  computer.addOutputField('upperResult'),
                                              lowerResult:  computer.addOutputField('lowerResult'),
                                              middleResult:  computer.addOutputField('middleResult'), 
                                            }
                                    );



    indicatorMapping.addField("dt", 0);
    indicatorMapping.addField("close", 4);
   //mapping.addField(({value: computer.addOutputField('result')});


    var sel = indicatorMapping.createSelectable().selectAll()
    var iter = sel.getIterator();


    let xN = 0;
    let yN = 0;
    let prevx = 0;
    let prevupper = 0;
    let prevlower = 0;
    let prevmiddle = 0;
    let prevclose = 0;
    let upper = 0;
    let lower = 0;
    let  middle = 0;
    let  close = 0;



    let upperResultLine:Segment[] = [];
    let lowerResultLine:Segment[] = [];
    let middleResultLine:Segment[] = [];
    let closeResultLine:Segment[] = [];

    let i = 0;

    //let testArray = [];
    while (iter.advance()) {

      //testArray.push({upper:upper, lower:lower, middle:middle,close:close });

       prevx = i;
       prevupper = upper;
       prevlower = lower;
       prevmiddle = middle;
       prevclose = close;




      upper = iter.get("upperResult");
      lower = iter.get("lowerResult");
      middle = iter.get("middleResult");
      close = iter.get("close");

    //   let ySignalPrev =  ySignal;

       i++; 
       xN = i;

    //   yN = macd;
    //   ySignal = signal;

    //  // console.log([prevx - x]);

     upperResultLine.push(
                            {
                              s:{x:prevx, y:prevupper},
                              e:{x:xN, y:upper}
                            }
                          )

    lowerResultLine.push(
                            {
                              s:{x:prevx, y:prevlower},
                              e:{x:xN, y:lower}
                            }
                          )   
                          
    middleResultLine.push(
                            {
                              s:{x:prevx, y:prevmiddle},
                              e:{x:xN, y:middle}
                            }
                          )   

    closeResultLine.push(
                            {
                              s:{x:prevx, y:prevclose},
                              e:{x:xN, y:close}
                            }
                          )      
      


    //   nSegmentedline2.push(
    //                           {
    //                             s:{x:prevx, y:ySignalPrev},
    //                             e:{x:xN, y:ySignal}
    //                           }
    //                       )

                            
     }

   // console.log(testArray);

   // console.log(nSegmentedline1);
   // console.log(nSegmentedline2);


    // let nSegmentedline1:Segment[] = [
    //     {s:{x:1,y:1},e:{x:2,y:2}},
    //     {s:{x:2,y:2},e:{x:3,y:1.5}},
    //     {s:{x:3,y:1.5},e:{x:4,y:1}},
    //     {s:{x:4,y:1},e:{x:5,y:1.5}},
    //     {s:{x:5,y:1.5},e:{x:6,y:0.5}},
    //     {s:{x:6,y:0.5},e:{x:7,y:2.5}},
    //     {s:{x:7,y:2.5},e:{x:8,y:2.5}},
    //     {s:{x:8,y:2.5},e:{x:9,y:2.5}},
    //   ]
    
    // let nSegmentedline2:Segment[] = [
    //     {s:{x:1,y:1.5},e:{x:2,y:1.5}},
    //     {s:{x:2,y:1.5},e:{x:3,y:1.5}},
    //     {s:{x:3,y:1.5},e:{x:4,y:1.5}},
    //     {s:{x:4,y:1.5},e:{x:5,y:1.5}},
    //     {s:{x:5,y:1.5},e:{x:6,y:1.5}},
    //     {s:{x:6,y:1.5},e:{x:7,y:1.5}},
    //     {s:{x:7,y:1.5},e:{x:8,y:1.5}},
    //     {s:{x:8,y:1.5},e:{x:9,y:1.5}},
    //   ]
    
  //  console.log(nSegmentedline1);
 //   console.log(nSegmentedline2);

 let closeUpperArray  = Object.assign([], closeResultLine);
 let lowerUpperArray  = Object.assign([], closeResultLine);
 let middleUpperArray  = Object.assign([], closeResultLine);

    let upperfirstSegmentRevIntersectionInformation:PointDirection[] | boolean = [];
    upperfirstSegmentRevIntersectionInformation = findFirstIntersectionsReversedWithCrossDirection(upperResultLine, closeUpperArray);//U>C => over
  // console.log(upperfirstSegmentRevIntersectionInformation); 

   let lowerfirstSegmentRevIntersectionInformation:PointDirection[] | boolean = [];
   lowerfirstSegmentRevIntersectionInformation = findFirstIntersectionsReversedWithCrossDirection(lowerResultLine, lowerUpperArray)
//  console.log(lowerfirstSegmentRevIntersectionInformation); 

  let middlefirstSegmentRevIntersectionInformation:PointDirection[] | boolean = [];
   middlefirstSegmentRevIntersectionInformation = findFirstIntersectionsReversedWithCrossDirection(middleResultLine, middleUpperArray)
 // console.log(middlefirstSegmentRevIntersectionInformation); 

     let uL = 0;
     let lL = 0;
     let mL = 0;

     if(upperfirstSegmentRevIntersectionInformation!=false&&upperfirstSegmentRevIntersectionInformation!=true)
     {
        uL = upperfirstSegmentRevIntersectionInformation.length
     }

     if(lowerfirstSegmentRevIntersectionInformation!=false&&lowerfirstSegmentRevIntersectionInformation!=true)
     {
        lL = lowerfirstSegmentRevIntersectionInformation.length
     }

     if(middlefirstSegmentRevIntersectionInformation!=false&&middlefirstSegmentRevIntersectionInformation!=true)
     {
       mL = middlefirstSegmentRevIntersectionInformation.length
     }
    
     let maxV = Math.min(uL,lL,mL);
     
     if(maxV == uL)
     {
          return ["upper", upperfirstSegmentRevIntersectionInformation];
     }

     if(maxV == lL)
     {
        return ["lower", lowerfirstSegmentRevIntersectionInformation];
     }

     if(maxV == mL)
     {
      return ["middle", middlefirstSegmentRevIntersectionInformation];
     }



     /**
      * 
      * 
      * [
      * M<C -> under => Buy
      * M>C -> over => Sell
      * 
      * 
      */


    //console.log(testArray);
     return false;//   firstSegmentRevIntersectionInformation;

}












